import type { ProfessionalTypeEnum } from '@gql/graphql';

export interface JoinProInfoProfilePageControllerData {
  type: ProfessionalTypeEnum;
}

export interface JoinProInfoProfilePageControllerProps
  extends JoinProInfoProfilePageControllerData {}
